module.exports = __webpack_public_path__ + "img/title.a100e1cd.png";